import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "..";
import axios from "axios";
import { getAuthToken } from "../../utils/utils";

// const token = getAuthToken();



// Thunks
export const addUser = createAsyncThunk("users/addUser", async (userData, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.post(`${baseUrl}/adduser`, userData,
      {
        headers: {
          'Authorization': `${token}`,  // Pass the token here
          'Content-Type': 'application/json',  // Make sure the content type is correct
        }
      }
    );
    return response.data.user;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error adding user");
  }
});

export const getUsers = createAsyncThunk("users/getUsers", async (_, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/getuser` ,
      {
        headers: {
          'Authorization': `${token}`,  // Pass the token here
          'Content-Type': 'application/json',  // Make sure the content type is correct
        }
      }
    );
    return response.data.users;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching users");
  }
});


export const getUserCount = createAsyncThunk("users/getUserCount", async (_, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/user-counts` ,{
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching users");
  }
});

export const findUserByName = createAsyncThunk("users/findUserByName", async (name, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/finduser/${name}` , {
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data.users;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error finding user");
  }
});

export const updateUser = createAsyncThunk("users/updateUser", async ({ id, updates }, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.put(`${baseUrl}/updateuser/${id}`, updates ,{
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data.user;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error updating user");
  }
});

export const deleteUser = createAsyncThunk("users/deleteUser", async (id, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.delete(`${baseUrl}/deleteuser/${id}` ,{
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data.user;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error deleting user");
  }
});

export const changeUserStatus = createAsyncThunk("users/changeUserStatus", async ({ id, status }, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.put(`${baseUrl}/changestatus/${id}`, { status } ,{
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data.user;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error changing user status");
  }
});

//
export const getUserById = createAsyncThunk("users/getUserById", async ( id , { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/userbyid/${id}` ,{
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response?.data?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error changing user status");
  }
});

//revenue data
export const getRevenue = createAsyncThunk("users/geRevenue", async (_, { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/monthly-revenue` ,{
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching revenue "); 
  }
});


export const getPaymentDetails = createAsyncThunk("users/getPaymentDetails", async ( userId , { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/get-user-payment-details` ,{
      params: {
        userId
      },
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching revenue "); 
  }
});
export const getUserYears = createAsyncThunk("users/getUserYears", async ( userId , { rejectWithValue }) => {
  try {
      const token = getAuthToken();
    const response = await axios.get(`${baseUrl}/user-program-years` ,{
      params: {
        userId
      },
      headers: {
        'Authorization': `${token}`,  // Pass the token here
        'Content-Type': 'application/json',  // Make sure the content type is correct
      }
    });
    return response.data?.yearRange;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Error fetching revenue "); 
  }
});

// Slice
const userSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    userCount: [],
    revenue: [],
    paymentDetails:{},
    systemYears:[],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Add User
    builder
      .addCase(addUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users.push(action.payload);
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Get Users
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

      // Get Users
    builder
    .addCase(getUserCount.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getUserCount.fulfilled, (state, action) => {
      state.loading = false;
      state.userCount = action.payload;
    })
    .addCase(getUserCount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //revene
    builder
    .addCase(getRevenue.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getRevenue.fulfilled, (state, action) => {
      state.loading = false;
      state.revenue = action.payload;
    })
    .addCase(getRevenue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Find User by Name
    builder
      .addCase(findUserByName.pending, (state) => {
        state.loading = true;
        state.error = null;

      })
      .addCase(findUserByName.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload; // Replace users with search results
      })
      .addCase(findUserByName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.users = []; // Clear users
      });

    // Update User
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        );
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Delete User
    builder
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = state.users.filter((user) => user._id !== action.payload._id);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Change User Status
    builder
      .addCase(changeUserStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeUserStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.users = state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        );
      })
      .addCase(changeUserStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Change User Status
    builder
    .addCase(getUserById.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getUserById.fulfilled, (state, action) => {
      state.loading = false;
      localStorage.setItem('userState', JSON.stringify(action.payload));
    })
    .addCase(getUserById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    //paymentDetails
    builder
    .addCase(getPaymentDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getPaymentDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.paymentDetails = action.payload;
    })
    .addCase(getPaymentDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    //get Years

    builder
    .addCase(getUserYears.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getUserYears.fulfilled, (state, action) => {
      state.loading = false;
      state.systemYears = action.payload;
    })
    .addCase(getUserYears.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

  },
});

export default userSlice.reducer;